"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useOpenApiRequestState = void 0;
var react_1 = __importDefault(require("react"));
var openApiRequestStatus_1 = require("./openApiRequestStatus");
/**
 * Returns a request state and a function to update it
 */
function useOpenApiRequestState() {
    var _a = react_1.default.useState({
        type: openApiRequestStatus_1.OpenApiRequestStatus.Initial,
    }), state = _a[0], setState = _a[1];
    return [state, setState];
}
exports.useOpenApiRequestState = useOpenApiRequestState;
